// CPF AND CNPJ
export const maskIdentification = (value: string): string => {
  const digits = value.replace(/\D/g, '');

  if (digits.length <= 11) {
    // CPF
    return digits
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d{1,2})?$/, "$1.$2.$3-$4")
      .replace(/[-.]$/, "");
  } else {
    // CNPJ
    return digits
      .replace(/^(\d{2})(\d)/, "$1.$2")
      .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
      .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2})?$/, "$1.$2.$3/$4-$5")
      .replace(/[-./]$/, "");
  }
};

export const maskDate = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  return digits
    .replace(/^(\d{2})(\d)/, "$1/$2")
    .replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3")
    .replace(/[/]$/, "");
};

export const maskPhone = (value: string): string => {
  const digits = value.replace(/\D/g, '');

  if (digits.length <= 10) {
    // Formato fixo: (99) 9999-9999
    return digits
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/^(\(\d{2}\)) (\d{4})(\d)/, "$1 $2-$3")
      .replace(/[-)]$/, ""); // evita separador no final
  } else {
    // Celular: (99) 99999-9999
    return digits
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/^(\(\d{2}\)) (\d{5})(\d)/, "$1 $2-$3")
      .replace(/[-)]$/, "");
  }
};

export const maskCnpj = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 14);
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{1,2})?$/, "$1.$2.$3/$4-$5")
    .replace(/[-./]$/, "");
};

export const maskCep = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  return digits.replace(/^(\d{5})(\d{1,3})?$/, "$1-$2").replace(/-$/, "");
};

//-- CREDIT CARD
export const maskExpiry = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(0, 4);
  return digits.replace(/^(\d{2})(\d{1,2})?$/, "$1/$2").replace(/\/$/, "");
};
